import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "cookie_consent";

export function getConsent() {
    try {
        return localStorage.getItem(KEY);
    } catch (e) {
        return null;
    }
}

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!getConsent()) {
            const t = setTimeout(() => setVisible(true), 600);
            return () => clearTimeout(t);
        }
    }, []);

    const decide = (value) => {
        try {
            localStorage.setItem(KEY, value);
        } catch (e) {}
        if (value === "granted") {
            window.dispatchEvent(new Event("cookie-consent-granted"));
        }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            role="dialog"
            aria-label="Zgoda na pliki cookie"
            data-testid="cookie-banner"
            className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-2xl rounded-2xl border border-border bg-card/95 p-5 shadow-xl backdrop-blur-xl sm:inset-x-auto sm:left-6 sm:bottom-6"
        >
            <div className="flex items-start gap-3">
                <div className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-gr-secondary text-gr-primary dark:bg-gr-dsecondary dark:text-gr-dprimary">
                    <Cookie className="h-5 w-5" />
                </div>
                <div className="flex-1">
                    <p className="text-sm font-semibold text-foreground">Szanujemy Twoją prywatność</p>
                    <p className="mt-1 text-sm text-muted-foreground">
                        Używamy plików cookie do analityki, aby ulepszać stronę. Możesz zaakceptować lub odrzucić — Twój wybór.{" "}
                        <Link to="/polityka-prywatnosci" className="font-medium text-gr-primary underline underline-offset-2 dark:text-gr-dprimary">
                            Polityka prywatności
                        </Link>
                        .
                    </p>
                    <div className="mt-4 flex flex-col gap-2 sm:flex-row">
                        <button
                            type="button"
                            data-testid="cookie-accept"
                            onClick={() => decide("granted")}
                            className="rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-transform hover:brightness-110 active:scale-95"
                        >
                            Akceptuję
                        </button>
                        <button
                            type="button"
                            data-testid="cookie-decline"
                            onClick={() => decide("denied")}
                            className="rounded-full border border-border px-5 py-2.5 text-sm font-semibold text-foreground transition-colors hover:bg-secondary active:scale-95"
                        >
                            Tylko niezbędne
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
